import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    const token = localStorage.getItem("pd_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem("pd_token");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.twofa_required) {
      return { twofaRequired: true, twofaToken: data.twofa_token };
    }
    if (data.access_token) {
      localStorage.setItem("pd_token", data.access_token);
    }
    setUser(data.user);
    return { user: data.user };
  };

  const verify2fa = async (twofaToken, code) => {
    const { data } = await api.post("/auth/2fa/verify", {
      twofa_token: twofaToken,
      code,
    });
    if (data.access_token) {
      localStorage.setItem("pd_token", data.access_token);
    }
    setUser(data.user);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    localStorage.removeItem("pd_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, verify2fa, logout, refresh: check }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
